import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TituloReceberIntegracaoErpImportService {
    /** Evento executado após finalizar a importação dos títulos a receber do ERP */
    afterImport = new Subject<void>();

    /** Emite o evento de finalização da importação dos títulos a receber do ERP */
    emitAfterImport() {
        this.afterImport?.next();
    }
}
